export const ENGLISH_UI_OVERRIDES = Object.freeze({
  "Distribusi Partner": "Partner distribution",
  "Template siap pakai": "Ready-to-use template",
  "Template instan": "Instant template",
  "Designer siap pakai": "Ready-to-use designer",
  "DSP tersimpan": "Saved DSP",
  "Template siap pakai dari project": "Ready-to-use template from project",
  "Template instrumen kosong": "Blank instrument template",
  "Template audio effect kosong": "Blank audio-effect template",
  "BAWAAN": "BUILT-IN",
  "Modul DSP": "DSP Modules",
  "Saturasi harmonik": "Harmonic saturation",
  "Kepadatan dynamics stereo": "Stereo dynamics density",
  "Level output instrumen": "Instrument output level",
  "Lebar stereo": "Stereo width",
  "Kecepatan awal suara": "Sound attack speed",
  "Panjang ekor suara": "Sound release length",
  "Dry/wet processor": "Processor dry/wet",
  "Gain keluaran effect": "Effect output gain",
  "Lewati seluruh DSP": "Bypass all DSP",
  "Bisukan output instrumen": "Mute instrument output",
  "Meter level keluaran": "Output level meter",
  "Tombol on/off": "On/off button",
  "Pad trigger sample": "Sample trigger pad",
  "Tuts piano interaktif": "Interactive piano keys",
  "Bend nada dua arah": "Bipolar pitch bend",
  "Tombol solo-safe output": "Solo-safe output button",
  "Tombol bisukan output": "Mute output button",
  "Dekorasi panel statis": "Static panel decoration",
  "FFT keluaran audio secara real-time": "Real-time audio output FFT",
  "Kiri atas": "Top left",
  "Tengah atas": "Top center",
  "Kanan atas": "Top right",
  "Kiri bawah": "Bottom left",
  "Tengah bawah": "Bottom center",
  "Kanan bawah": "Bottom right",
  "Tampilan & layout": "Appearance & layout",
  "Project, sample & zone": "Projects, samples & zones",
  "Efek, modul & macro": "Effects, modules & macros",
  "Menyiapkan project": "Preparing project",
  "Memvalidasi VST3": "Validating VST3",
  "Mengambil sample": "Fetching samples",
  "Membuat VST3": "Building VST3",
  "Memeriksa plugin": "Checking plugin",
  "Siap diunduh": "Ready to download",
  "Hubungkan MIDI": "Connect MIDI",
  "Hubungkan MIDI controller": "Connect a MIDI controller",
  "Refresh koneksi MIDI": "Refresh MIDI connection",
  "MIDI aktif": "MIDI connected",
  "Pilih MIDI": "Select MIDI",
  "Pilih MIDI controller": "Select a MIDI controller",
  "Tambah komponen": "Add component",
  "Upload gambar": "Upload image",
  "Mengunggah gambar…": "Uploading image…",
  "Upload background": "Upload background",
  "Ganti background": "Replace background",
  "Hapus background": "Remove background",
  "Mengunggah…": "Uploading…",
  "Sumber suara": "Sound source",
  "Rentang nada": "Note range",
  "Tambah sampler": "Add sampler",
  "Modulasi": "Modulation",
  "Pasang Legend Channel": "Install Legend Channel",
  "Tambah hardware": "Add hardware",
  "Pasang rack standar": "Install standard rack",
  "Pasang amp simulator": "Install amp simulator",
  "Pasang Amp Simulator": "Install Amp Simulator",
  "Tambah modul": "Add module",
  "Tambahkan modul": "Add module",
  "Generator suara": "Sound Generator",
  "Knob studio sederhana": "Simple studio knob",
  "Pointer analog · skala MIN/MAX": "Analog pointer · MIN/MAX scale",
  "CSS presisi · black hardware": "Precision CSS · black hardware",
  "Bakelite merah · dual wing": "Red bakelite · dual wing",
  "Graphite hitam · dual wing": "Black graphite · dual wing",
  "Porcelain putih · dual wing · amber marker": "White porcelain · dual wing · amber marker",
  "Graphite dome · indikator oranye": "Graphite dome · orange indicator",
  "CSS presisi · bilah diagonal": "Precision CSS · diagonal blade",
  "Ivory · tuas aluminium · MIN/MAX": "Ivory · aluminum lever · MIN/MAX",
  "LED kontinu terpisah · center detent": "Separate continuous LED · center detent",
  "LED titik terpisah · center detent": "Separate LED dots · center detent",
  "Tombol bulat sederhana": "Simple round button",
  "Lampu hardware 3D": "3D hardware lamp",
  "Saklar horizontal": "Horizontal switch",
  "Push switch chrome · PNG realistis": "Chrome push switch · realistic PNG",
  "Tombol solo kuning": "Yellow solo button",
  "Tombol mute merah": "Red mute button",
  "Fader minimal": "Minimal fader",
  "Fader studio vintage": "Vintage studio fader",
  "Fader metal 3D · skala presisi · status LED": "3D metal fader · precision scale · status LED",
  "Meter vertikal cepat": "Fast vertical meter",
  "Meter jarum 3D": "3D needle meter",
  "Meter analog gelap": "Dark analog meter",
  "Dual 16-segment · hijau, kuning, peak merah": "Dual 16-segment · green, yellow, red peak",
  "11 garis · MIN / MAX": "11 lines · MIN / MAX",
  "21 garis presisi · MIN / MAX": "21 precision lines · MIN / MAX",
  "15 titik · MIN / MAX": "15 dots · MIN / MAX",
  "Major/minor tegas · 0–10": "Bold major/minor · 0–10",
  "Busur minimal · MIN / MAX": "Minimal arc · MIN / MAX",
  "FFT output nyata · native live": "Real output FFT · live native",
  "Gelombang output nyata · native live": "Real output waveform · live native",
  "48 band FFT simetris · real-time": "48 symmetrical FFT bands · real-time",
  "Stereo phase scope · correlation −1 hingga +1": "Stereo phase scope · correlation −1 to +1",
  "Pad sampler klasik": "Classic sampler pad",
  "Edge glow responsif": "Responsive edge glow",
  "Keyboard standar": "Standard keyboard",
  "Keyboard synth gelap": "Dark synth keyboard",
  "Mod wheel MIDI · vibrato hingga ±0.5 semitone": "MIDI mod wheel · vibrato up to ±0.5 semitone",
  "Label & merek VST": "VST label & branding",
  "Nama plugin": "Plugin name",
  "Jenis plugin": "Plugin type",
  "Jenis instrumen": "Instrument type",
  "Jenis font brand": "Brand font",
  "Rata teks": "Text alignment",
  "Kiri": "Left",
  "Tengah": "Center",
  "Kanan": "Right",
  "Lebar kanvas (px)": "Canvas width (px)",
  "Tinggi kanvas (px)": "Canvas height (px)",
  "Nonaktifkan Grid Snap": "Disable Grid Snap",
  "Aktifkan Grid Snap": "Enable Grid Snap",
  "Riwayat perubahan Designer": "Designer change history",
  "Urungkan perubahan Designer": "Undo Designer change",
  "Ulangi perubahan Designer": "Redo Designer change",
  "Kunci rasio resize": "Lock resize ratio",
  "Resize konstan · rasio komponen dikunci": "Proportional resize · component ratio locked",
  "Tutup panel": "Close panel",
  "komponen terpilih": "selected components",
  "Ganti komponen": "Replace component",
  "Output sampler": "Sampler output",
  "Gambar": "Image",
  "Ubah lebar": "Change width",
  "Kategori komponen": "Component category",
  "Tambah": "Add",
  "Tambah ": "Add ",
  "Hapus ": "Delete ",
  "Ubah ": "Change ",
  "Tutup pilihan komponen": "Close component picker",
  "Tutup pilihan background": "Close background picker",
  "Ganti komponen ·": "Replace component ·",
  "Kategori komponen pengganti": "Replacement component category",
  "Ketebalan garis Realtime Waveform": "Realtime Waveform line thickness",
  "Ketebalan batang Bar Spectrum": "Bar Spectrum bar thickness",
  "Urutan lapisan": "Layer order",
  "Lapisan": "Layer",
  "Atur urutan lapisan komponen": "Adjust component layer order",
  "Isi text": "Text content",
  "Label komponen": "Component label",
  "Font text": "Text font",
  "Metering kontinu non-LED": "Continuous non-LED metering",
  "Metering di samping fader": "Metering beside the fader",
  "Kanan fader": "Right of fader",
  "Kiri fader": "Left of fader",
  "Lebar metering ·": "Meter width ·",
  "Tinggi metering ·": "Meter height ·",
  "Ketebalan ring ·": "Ring thickness ·",
  "Intensitas nyala ring ·": "Ring glow intensity ·",
  "Ketebalan font angka": "Value font weight",
  "Bentuk tombol": "Button shape",
  "Kotak": "Square",
  "Kapsul": "Capsule",
  "Bulat": "Round",
  "Jarak antar tombol ·": "Button spacing ·",
  "Atur jarak vertikal teks status ON/OFF terhadap mechanical toggle": "Adjust the vertical spacing of the ON/OFF status text from the mechanical toggle",
  "Status komponen": "Component status",
  "Sampler target": "Target sampler",
  "Output awal ·": "Initial output ·",
  "Pilihan output": "Output selection",
  "Fungsi panel": "Panel function",
  "Isi panel": "Panel contents",
  "Lebar panel ·": "Panel width ·",
  "Tinggi panel ·": "Panel height ·",
  "Nada pad": "Pad note",
  "Reset tuts": "Reset keys",
  "Fungsi native": "Native function",
  "Sampler sumber": "Source sampler",
  "Master / komponen lain": "Master / other component",
  "Sumber indikator": "Indicator source",
  "Status manual": "Manual status",
  "Mati": "Off",
  "Nyala": "On",
  "Ganti gambar": "Replace image",
  "Opacity gambar": "Image opacity",
  "File gambar": "Image file",
  "Gambar upload": "Uploaded image",
  "Sumber meter": "Meter source",
  "Gain Reduction compressor": "Compressor gain reduction",
  "Compressor target": "Target compressor",
  "Compressor pertama di rack": "First compressor in the rack",
  "Sumber monitoring": "Monitoring source",
  "Mode meter": "Meter mode",
  "Mono · level gabungan": "Mono · combined level",
  "Stereo · kanal L / R": "Stereo · L / R channels",
  "Peak output aktual": "Actual output peak",
  "RMS / VU output aktual": "Actual RMS / VU output",
  "Target modul": "Target module",
  "Parameter sampler": "Sampler parameter",
  "Parameter modul": "Module parameter",
  "Bypass modul": "Bypass module",
  "Target Solo + Mute": "Solo + Mute target",
  "Target Solo": "Solo target",
  "Target Mute": "Mute target",
  "Sampler pemicu": "Trigger sampler",
  "Background komponen": "Component background",
  "Hilangkan kotak pembungkus": "Remove container box",
  "Lebar keyboard (px)": "Keyboard width (px)",
  "Tinggi keyboard (px)": "Keyboard height (px)",
  "Opacity komponen": "Component opacity",
  "Rotasi komponen": "Component rotation",
  "Derajat rotasi komponen": "Component rotation degrees",
  "Mixer Sampler": "Sampler Mixer",
  "Nama sampler": "Sampler name",
  "Mode mapping": "Mapping mode",
  "Kecepatan asli": "Original speed",
  "Tempo sumber": "Source tempo",
  "Tempo sumber BPM": "Source tempo BPM",
  "Key range bawah": "Lower key range",
  "Key range atas": "Upper key range",
  "Choke target ·": "Choke target ·",
  "Tambah note choke target": "Add choke target note",
  "Tambah note…": "Add note…",
  "Velocity bawah ·": "Lower velocity ·",
  "Velocity atas ·": "Upper velocity ·",
  "Piano roll dibatasi hingga 128 nada per project": "The piano roll is limited to 128 notes per project",
  "Panjang nada": "Note length",
  "nada · 2 bar": "notes · 2 bars",
  "Nada": "Note",
  "Tambah nada": "Add note",
  "Sumber audio": "Audio source",
  "Panel & binding": "Panel & bindings",
  " komponen": " components",
  "Project instrumen kosong": "Blank instrument project",
  "Project audio effect kosong": "Blank audio-effect project",
  "Tambah template": "Add template",
  "Template bawaan tersembunyi": "Hidden built-in template",
  "Ganti thumbnail template": "Replace template thumbnail",
  "Sumber & DSP Processor": "Source & DSP Processor",
  "Buka": "Open",
  "Tutup daftar modul": "Close module list",
  " pilihan": " options",
  "Target DSP": "DSP target",
  "Ganti IR WAV": "Replace IR WAV",
  "Atur generator": "Configure generator",
  "Mode chord": "Chord mode",
  "Jenis chord": "Chord type",
  "Nada step": "Step notes",
  "Tambah WAV": "Add WAV",
  "Putar": "Play",
  "Nama preset “": "Preset name “",
  "Penempatan gambar": "Image placement",
  "Lampu indikator mati": "Indicator light off",
  "Merek / developer": "Brand / developer",
  "Versi plugin": "Plugin version",
  "Modulation Wheel MIDI CC1 · vibrato hingga ±0.5 semitone": "MIDI CC1 Modulation Wheel · vibrato up to ±0.5 semitone",
  "Contextual · 3 knob bersama": "Contextual · 3 shared knobs",
  "Direct · node analyzer saja": "Direct · analyzer node only",
  "Identitas & versi": "Identity & version",
  "Audio tersimpan privat": "Audio stored privately",
  "Sample mapping valid": "Valid sample mapping",
  "Konfigurasi sound": "Sound configuration",
  "Kesiapan build": "Build readiness",
  "siap": "ready",
  "Antrean": "Queue",
  "Menunggu worker": "Waiting for worker",
  "Menunggu worker Windows": "Waiting for Windows worker",
  "Menunggu worker macOS": "Waiting for macOS worker",
  "Persiapan": "Preparation",
  "Kompilasi": "Compilation",
  "Validasi": "Validation",
  "Selesai": "Complete",
  "Progress build": "Build progress",
  "Ciutkan panel progress build": "Collapse build progress panel",
  "Status build sedang diperbarui": "Build status is updating",
  "Batalkan build": "Cancel build",
  "Ulangi build": "Retry build",
  "Salin serial": "Copy license key",
  " komputer": " computers",
  "komputer": "computers",
  "terakhir": "latest",
  "Unduh build terakhir": "Download latest build",
  "Pilih build terakhir untuk diunduh": "Select the latest build to download",
  "Unduh Windows terakhir": "Download latest Windows build",
  "Unduh macOS terakhir": "Download latest macOS build",
  "Menunggu worker build Windows": "Waiting for the Windows build worker",
  "Menunggu worker build macOS": "Waiting for the macOS build worker",
  "Worker Windows menyiapkan build": "Windows worker is preparing the build",
  "Worker macOS menyiapkan build": "macOS worker is preparing the build",
  "Aset build tidak dapat disiapkan": "Build assets could not be prepared",
  "VST3 Windows siap diunduh": "Windows VST3 is ready to download",
  "VST3 macOS siap diunduh": "macOS VST3 is ready to download",
  "Masa simpan artifact berakhir": "Artifact retention period ended",
  "Menyimpan project dan memasukkan build ke antrean…": "Saving the project and adding the build to the queue…",
  "Lihat detail": "View details",
  "Admin akan mencocokkan bukti dengan mutasi rekening.": "Our team will match the receipt against the bank statement.",
  "Batas pembayaran:": "Payment deadline:",
  "belum memiliki zona": "doesn't have a zone yet",
  "Buat serial": "Issue license key",
  "Jual VST Anda dengan serial unik untuk setiap pembeli. Penerbitan dapat dilakukan manual atau otomatis melalui API.": "Sell your VST with a unique license key for every buyer. Keys can be issued manually or automatically through the API.",
  "Kirim ulang email": "Resend email",
  "Lisensi Distribusi": "License Distribution",
  "Nominal transfer": "Transfer amount",
  "Pembayaran disetujui": "Payment approved",
  "Pembayaran kedaluwarsa": "Payment expired",
  "Rekening Tujuan": "Destination Bank Account",
  "Simpan API key ini sekarang — hanya ditampilkan satu kali.": "Save this API key now — it is shown only once.",
  "Tersedia setelah build berhasil": "Available after a successful build",
  "Transfer Bank Manual": "Manual Bank Transfer",
  "Sample Pack dan Sound Bank": "Sample Pack and Sound Bank",
  "Vst Instrument Virtual Kendang Dengan Kendang KIt Lengkap Mulai Dari Tabla, Mika, Kempul, Kendang Jaranan Dengan Banyak Fitur Preset dan Multiple Output Serta Banyak Pilihan Midi File di Dalamnya.": "A complete virtual kendang instrument featuring tabla, mika, kempul, and kendang jaranan kits, with presets, multiple outputs, and an extensive MIDI groove library.",
  "· Masa simpan berakhir": "· Retention period ended",
  "Beri rating 1–5 bintang untuk hasil project yang sudah selesai. Satu pesanan dapat dinilai satu kali.": "Rate the completed project from 1–5 stars. Each order can be rated once.",
  "Buat ulang API key": "Regenerate API key",
  "Build ini dihentikan. Tombol Eksport VST": "This build was stopped. The Export VST button",
  "Build ini mengikuti ketentuan marketplace eksklusif dan bagi hasil Partner.": "This build follows the exclusive marketplace and Partner revenue-sharing terms.",
  "Build total": "Total builds",
  "diterapkan lengkap dengan Mapping, Sample, Wave Generator, dan DSP": "applied with its complete Mapping, Samples, Wave Generator, and DSP",
  "Engineer menerima pengajuan Anda. Silakan lanjutkan pembayaran melalui DOKU. Chat dengan engineer akan aktif setelah pembayaran dikonfirmasi.": "The engineer accepted your request. Continue to DOKU payment; chat becomes available once payment is confirmed.",
  "File sumber yang sudah dikonfirmasi engineer akan dihapus 30 hari setelah project selesai. Simpan salinan Anda sendiri.": "Source files confirmed by the engineer are deleted 30 days after project completion. Keep your own copy.",
  "Gagal menyimpan rekening": "Could not save the bank account",
  "Hak build aktif otomatis setelah pembayaran lunas": "Build rights activate automatically after payment is complete",
  "Hasil disetujui; payout engineer masuk antrean admin": "Final delivery approved; the engineer payout is queued for review",
  "Produk dan lisensi sudah tersedia di dashboard Anda.": "Your product and license are now available in your dashboard.",
  "Harga penambahan kuota belum tersedia secara self-service. Hubungi tim kami untuk kebutuhan di atas 100 atau 1.000 serial.": "Additional license-key quotas are not yet available through self-service. Contact our team if you need more than 100 or 1,000 keys.",
  "Personal dan Creator mendapat satu perangkat; Creator Commercial dan Studio Commercial memperoleh kuota serial komersial.": "Personal and Creator support one device; Creator Commercial and Studio Commercial include commercial license-key quotas.",
  "Saat plugin pertama dibuka, salin serial ini lalu tekan Aktivasi dari Clipboard. Aktivasi tersimpan aman pada komputer tersebut.": "When the plugin first opens, copy this license key and select Activate from Clipboard. The activation is stored securely on that computer.",
  "Serial lisensi disalin": "License key copied",
  "Serial lisensi build · maksimal": "Build license keys · maximum",
  "Setiap serial Creator Commercial, Studio Commercial, dan Partner berlaku untuk": "Each Creator Commercial, Studio Commercial, and Partner license key supports",
  "Serial dibuat dan dikirim": "License key issued and emailed",
  "Serial dibuat; email belum terkirim": "License key issued; email delivery is pending",
  "Serial gagal dibuat": "License key could not be issued",
  "Tetapkan jumlah komputer yang dapat memakai setiap serial Creator Commercial, Studio Commercial, dan Partner. Personal dan Creator selalu satu komputer.": "Set how many computers each Creator Commercial, Studio Commercial, and Partner license key can activate. Personal and Creator always support one computer.",
});
